import React, { useState, useEffect } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import {
  Modal,
  Spinner,
  Input,
  Col,
  Row,
  FormGroup,
  Label,
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { getEvents } from "@/services/program/getEvents";
import { getEvent } from "@/services/program/getEvent";
import {
  labelizeNamedData,
  isBadgeAward,
  flashDispatch,
  flashMessage,
  amountToUsFormat,
  isCustomAward,
  isScheduledAwardEnabled,
  isScheduledAwardRequired,
    getAwardMessage
} from "@/shared/helpers";
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage";
import axios from "axios";
import formValidation from "@/validation/giveReward";
import DatePickerField from "@/shared/components/form/DatePicker";
import EVENT_TYPES from "@/shared/json/eventTypes.json";
import { useTranslation } from "react-i18next";
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'

const DEFAULT_MSG_PARTICIPANT ="Thank you";
// const Participants = [
//   'Bobrowski Robert'
// ]
const GiveRewardPopup = ({
  setRefreshUsers,
  isOpen,
  toggle,
  participants,
  program,
  organization,
  rootProgram
}) => {
  // console.log(theme)
  const dispatch = flashDispatch();
  const { t } = useTranslation();
  const selectMenuPortalTarget = typeof document !== "undefined" ? document.body : null;
  // console.log(participants)
  const [events, setEvents] = useState([]);
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingEvent, setLoadingEvent] = useState(false);
  const [saving, setSaving] = useState(false);

  const [matchingAwardLevelAmount, setMatchingAwardLevelAmount] = useState(null);
  const [awardLevelMismatchError, setAwardLevelMismatchError] = useState(null);

  const participantAwardLevel = participants && participants.length > 0 ? participants[0].award_level : null;

  const validateAwardLevelMatch = () => {
    if (!program?.use_award_levels) return null;
    if (!participants || participants.length === 0) return null;

    const firstLevel = participants[0].award_level;
    const mismatch = participants.some((p) => p.award_level !== firstLevel);

    if (mismatch) {
      return "You can’t make awards to participants with different award levels. All participants must have the same award level.";
    }
    return null;
  };

  useEffect(() => {
    const error = validateAwardLevelMatch();
    setAwardLevelMismatchError(error);
  }, [participants, program?.use_award_levels]);

  const onChangeAwardValue = (event, form, inputOnChange, currentMax) => {
    const nextValue = event.target.value;

    if (nextValue === "") {
      inputOnChange(nextValue);
      form.change("awarding_points", program.factor_valuation * currentMax);
      return;
    }

    if (isNaN(nextValue)) return;

    const numericValue = Number(nextValue);
    if (numericValue > currentMax) {
      alert(`Value cannot exceed max awardable amount ${currentMax}`);
      inputOnChange(String(currentMax));
      form.change("awarding_points", program.factor_valuation * currentMax);
      return;
    }

    inputOnChange(nextValue);
    form.change("awarding_points", program.factor_valuation * numericValue);
  };

  const onSubmit = (values) => {
    if (program?.use_award_levels && awardLevelMismatchError) {
      dispatch(flashMessage(awardLevelMismatchError , "alert-danger"));
      return;
    }
    // console.log(JSON.stringify( values ))
    let formData = {
      event_id: values.event_id,
      notes: values.notes,
      message: values.message,
      restrictions: values.restrictions ? values.restrictions : null,
      user_id: participants.map((p) => p.id),
      override_cash_value: values.override_cash_value
        ? values.override_cash_value
        : null,
      referrer: values.referrer ? values.referrer : null
    };
    if (values?.email_template_id && values.email_template_id?.value && !isNaN(values.email_template_id.value)) {
      formData["email_template_id"] = parseInt(values.email_template_id.value)
    }
    if ( isScheduledAwardEnabled(rootProgram, program, event) ) {
      if( isScheduledAwardRequired(rootProgram, program) ) {
        if ( !values.scheduled_date ) {
          dispatch(flashMessage("Scheduled Award Date is required", "alert-danger"));
          return;
        }
      }

      if( values.scheduled_date )
      {
        let scheduleDate = values.scheduled_date.toLocaleDateString("en-CA");
        formData["scheduled_date"] = scheduleDate;
      }
    }
    setSaving(true)

    axios
      .post(
        `/organization/${organization.id}/program/${program.id}/award`,
        formData
      )
      .then((res) => {
        //   console.log(res)
        if (res.status === 200) {
          toggle()
          dispatch(
            flashMessage(
              "Participants Awarded successfully!"
            )
          );
          setSaving(false)
          for (const checkbox of document.querySelectorAll('.points-summary-table input[type="checkbox"]')) {
            checkbox.checked = false;
          }
          setRefreshUsers(true);
          window.location.reload()
        }
      })
      .catch((err) => {
        //console.log(error.response.data);
        dispatch(
          flashMessage(
            <ApiErrorMessage errors={err.response.data} />,
            "alert-danger",
            "top"
          )
        );
        setSaving(false);
      });
  };

  const onChangeEvent = (selectedOption, change) => {
    if (!selectedOption?.value) return;

    setLoadingEvent(true);
    getEvent(organization.id, program.id, selectedOption.value)
      .then((item) => {
        const matchingAwardLevel = (item.eventAwardsLevel || []).find((level) =>
          String(level.award_level_id) === String(participantAwardLevel) ||
          String(level.id) === String(participantAwardLevel) ||
          level.name === participantAwardLevel
        );
        const nextAwardAmount = matchingAwardLevel ? matchingAwardLevel.amount : null;
        const nextMessage = getAwardMessage(item);

        setMatchingAwardLevelAmount(nextAwardAmount);
        setEvent(item);

        if (typeof change === "function") {
          change("event_id", item.id);
          change("event_type_id", item.event_type_id);
          change("override_cash_value", "");
          change(
            "awarding_points",
            !isBadgeAward(item.event_type_id) && !isCustomAward(item.event_type_id)
              ? program.factor_valuation * (nextAwardAmount ?? item.max_awardable_amount)
              : ""
          );
          change("message", nextMessage);
        }
      })
      .catch(() => {
        dispatch(flashMessage("Unable to load reward event details.", "alert-danger", "top"));
      })
      .finally(() => {
        setLoadingEvent(false);
      });
  };

  useEffect(() => {
    if (!organization?.id || !program?.id) return;
    let mounted = true;
    setLoading(true);
    const except_type = [
      EVENT_TYPES.find((type) => type.name === "peer2peer allocation")?.value,
      EVENT_TYPES.find((type) => type.name === "peer2peer")?.value,
      EVENT_TYPES.find((type) => type.name === "peer2peer badge")?.value,
    ];
    getEvents(organization.id, program.id, { except_type }).then(
      (items) => {
        if (mounted) {
          // console.log(items)
          if (items.length > 0) {
            setEvents(labelizeNamedData(items));
            const [first] = items;
            const matchingAwardLevel = (first.eventAwardsLevel || []).find((level) =>
              String(level.award_level_id) === String(participantAwardLevel) ||
              String(level.id) === String(participantAwardLevel) ||
              level.name === participantAwardLevel
            );
            setMatchingAwardLevelAmount(matchingAwardLevel ? matchingAwardLevel.amount : null);
            setEvent(first);
          } else {
            setEvents([]);
            setEvent(null);
            setMatchingAwardLevelAmount(null);
          }
          setLoading(false);
        }
      }
    ).catch(() => {
      if (mounted) {
        setEvents([]);
        setEvent(null);
        setMatchingAwardLevelAmount(null);
        setLoading(false);
      }
      dispatch(flashMessage("Unable to load reward events.", "alert-danger", "top"));
    });
    return () => (mounted = false);
  }, [dispatch, organization?.id, participantAwardLevel, program?.id]);

  const selectedEventOption = event ? labelizeNamedData([event])?.[0] : null;
  const participantList = participants || [];

  let initialValues = {};
  if (event) {
    initialValues = {
      ...initialValues,
      event_id: event.id,
      event_type_id: event.event_type_id,
      awarding_points: program.factor_valuation * (matchingAwardLevelAmount ?? event.max_awardable_amount),
      message: getAwardMessage(event),
    };
  }

  return (
    <Modal
      className="program-settings manager-program-settings-modal modal-xl manager-reward-modal"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="manager-program-settings-modal__layout">
        <div className="manager-program-settings-modal__main">
          <div className="manager-program-settings-modal__header">
            <div className="manager-program-settings-modal__header-copy">
              <h3 className="manager-program-settings-modal__title">Give A Reward</h3>
              <p className="manager-program-settings-modal__subtitle">
                Choose an event, review the selected participants, and send the reward message.
              </p>
            </div>
            <button
              type="button"
              className="manager-program-settings-modal__close"
              onClick={toggle}
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div className="manager-program-settings-modal__body">
            {loading ? (
              <div className="manager-reward-modal__loading">
                <Spinner size="sm" />
                <span>{t("loading")}</span>
              </div>
            ) : (
              <Form
                onSubmit={onSubmit}
                initialValues={initialValues}
                validate={(values) => formValidation.validateForm(values)}
              >
                {({ handleSubmit, form, values }) => {
                  const selectedCount = participantList.length;
                  const currentMaxAward = Number(matchingAwardLevelAmount ?? event?.max_awardable_amount ?? 0);
                  const hasCustomAwardValue =
                    values?.override_cash_value !== undefined && values?.override_cash_value !== "";
                  const enteredAwardValue = hasCustomAwardValue
                    ? Number(values.override_cash_value)
                    : 0;
                  const customAwardValue = hasCustomAwardValue
                    ? enteredAwardValue
                    : currentMaxAward;
                  const displayAwardValue = hasCustomAwardValue
                    ? enteredAwardValue
                    : 0;
                  const isVariableAmountAward = event && !isBadgeAward(event.event_type_id) && !isCustomAward(event.event_type_id);
                  const totalAwardValue = isVariableAmountAward
                    ? displayAwardValue * selectedCount
                    : null;
                  const scheduledDateLabel = values?.scheduled_date
                    ? values.scheduled_date.toLocaleDateString()
                    : "Not scheduled";
                  const isSubmitDisabled = saving || loadingEvent || !event || !!awardLevelMismatchError;

                  return (
                    <form className="form manager-reward-modal__form" onSubmit={handleSubmit}>
                      {saving && (
                        <div className="manager-reward-modal__status">
                          <Spinner size="sm" />
                          <span>Saving, please wait...</span>
                        </div>
                      )}

                      <div className="manager-reward-modal__grid">
                        <div className="manager-reward-modal__main-column">
                          <section className="manager-reward-modal__hero">
                            <div className="manager-reward-modal__hero-copy">
                              <span className="manager-card__eyebrow">Recognition</span>
                              <h4 className="manager-reward-modal__hero-title">Configure the reward</h4>
                              <p className="manager-reward-modal__hero-description">
                                Select the event, adjust the award amount when allowed, and review the participant message before sending.
                              </p>
                            </div>
                          </section>

                          <section className="manager-reward-modal__section">
                            <div className="manager-reward-modal__section-head">
                              <h5>Event Selection</h5>
                              {loadingEvent && <span className="manager-reward-modal__inline-note">Refreshing reward details…</span>}
                            </div>
                            <Field name="event_id">
                              {({ input, meta }) => (
                                <FormGroup>
                                  <Select
                                    onChange={(selectedOption) => {
                                      input.onChange(selectedOption?.value || null);
                                      onChangeEvent(selectedOption, form.change);
                                    }}
                                    options={events}
                                    isClearable={false}
                                    isDisabled={loadingEvent || saving || events.length === 0}
                                    className="react-select"
                                    placeholder="Select an Event"
                                    classNamePrefix="react-select"
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                    menuPortalTarget={selectMenuPortalTarget}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 2000,
                                      }),
                                    }}
                                    value={selectedEventOption}
                                  />
                                  {meta.touched && meta.error && (
                                    <span className="text-danger">{meta.error}</span>
                                  )}
                                </FormGroup>
                              )}
                            </Field>
                          </section>

                          {event ? (
                            <>
                              <section className="manager-reward-modal__section">
                                <div className="manager-reward-modal__section-head">
                                  <h5>Award Details</h5>
                                </div>
                                {!!program?.use_award_levels && awardLevelMismatchError && (
                                  <div className="text-danger">{awardLevelMismatchError}</div>
                                )}

                                {isVariableAmountAward && (
                                  <>
                                    <Row>
                                      <Col md="6">
                                        <Label>Maximum cash value per participant</Label>
                                      </Col>
                                      <Col md="6">
                                        <div className="manager-reward-modal__value">
                                          {amountToUsFormat(currentMaxAward, true, "$")}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md="6">
                                        <Label>Custom cash value per participant</Label>
                                      </Col>
                                      <Col md="6">
                                        <Field name="override_cash_value">
                                          {({ input, meta }) => (
                                            <FormGroup>
                                              <Input
                                                placeholder={`Enter an amount < $${currentMaxAward}`}
                                                type="text"
                                                {...input}
                                                onChange={(event) =>
                                                  onChangeAwardValue(
                                                    event,
                                                    form,
                                                    input.onChange,
                                                    currentMaxAward
                                                  )
                                                }
                                              />
                                              {meta.touched && meta.error && (
                                                <span className="text-danger">{meta.error}</span>
                                              )}
                                            </FormGroup>
                                          )}
                                        </Field>
                                      </Col>
                                    </Row>
                                  </>
                                )}

                                {isScheduledAwardEnabled(rootProgram, program, event) && (
                                  <Row>
                                    <Col md="4">
                                      <Label>Scheduled Date*</Label>
                                    </Col>
                                    <Col md="4">
                                      <Field name="scheduled_date">
                                        {({ input, meta }) => (
                                          <FormGroup className="manager-reward-modal__compact-field">
                                            <DatePickerField
                                              minDate={new Date()}
                                              dateFormat="yyyy/MM/dd"
                                              onChange={(date) => input.onChange(date)}
                                            />
                                            {meta.touched && meta.error && (
                                              <span className="text-danger">{meta.error}</span>
                                            )}
                                          </FormGroup>
                                        )}
                                      </Field>
                                    </Col>
                                  </Row>
                                )}
                              </section>

                              <section className="manager-reward-modal__section">
                                <div className="manager-reward-modal__section-head">
                                  <h5>Message & Notes</h5>
                                </div>
                                <Row>
                                  <Col md="12">
                                    <Label className="mb-1">Award Notes (optional)</Label>
                                    <Field name="notes">
                                      {({ input, meta }) => (
                                        <FormGroup>
                                          <Input
                                            placeholder="Reward Notes(optional)"
                                            type="textarea"
                                            {...input}
                                          />
                                          {meta.touched && meta.error && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </FormGroup>
                                      )}
                                    </Field>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="12">
                                    <Label className="mb-1">Award Message</Label>
                                    <Field name="message">
                                      {({ input, meta }) => (
                                        <FormGroup>
                                          {!event.award_message_editable ? (
                                            <div
                                              className="manager-reward-modal__message-preview"
                                              dangerouslySetInnerHTML={{ __html: input.value }}
                                            />
                                          ) : (
                                            <WYSIWYGEditor
                                              value={input.value}
                                              onChange={input.onChange}
                                              onBlur={input.onBlur}
                                              placeholder="Message to Participant(s)"
                                            />
                                          )}
                                          {meta.touched && meta.error && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </FormGroup>
                                      )}
                                    </Field>
                                  </Col>
                                </Row>
                                {isCustomAward(event.event_type_id) && (
                                  <Row>
                                    <Col md="12">
                                      <Label className="mb-1">Restrictions</Label>
                                      <Field name="restrictions">
                                        {({ input, meta }) => (
                                          <FormGroup>
                                            <Input
                                              placeholder="Restrictions"
                                              type="textarea"
                                              {...input}
                                            />
                                            {meta.touched && meta.error && (
                                              <span className="text-danger">{meta.error}</span>
                                            )}
                                          </FormGroup>
                                        )}
                                      </Field>
                                    </Col>
                                  </Row>
                                )}
                              </section>

                              <section className="manager-reward-modal__section">
                                <div className="manager-reward-modal__section-head">
                                  <h5>Supporting Details</h5>
                                </div>
                                <Row>
                                  <Col md="6">
                                    <Label>Documentation</Label>
                                    <Field name="doc_file">
                                      {({ input, meta }) => (
                                        <FormGroup>
                                          <Input
                                            placeholder="Browse"
                                            type="file"
                                            {...input}
                                          />
                                          {meta.touched && meta.error && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </FormGroup>
                                      )}
                                    </Field>
                                  </Col>
                                  <Col md="6">
                                    <Label>Referrer</Label>
                                    <Field name="referrer">
                                      {({ input, meta }) => (
                                        <FormGroup>
                                          <Input
                                            placeholder="Referrer"
                                            type="text"
                                            {...input}
                                          />
                                          {meta.touched && meta.error && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </FormGroup>
                                      )}
                                    </Field>
                                  </Col>
                                </Row>
                              </section>
                            </>
                          ) : (
                            <section className="manager-reward-modal__section">
                              <div className="manager-reward-modal__empty">
                                No reward events are available for this program yet.
                              </div>
                            </section>
                          )}
                        </div>

                        <aside className="manager-reward-modal__rail">
                          <section className="manager-reward-modal__summary-card">
                            <div className="manager-reward-modal__summary-head">
                              <span className="manager-card__eyebrow">Summary</span>
                              <h5>Selected Participants</h5>
                            </div>
                            <div className="manager-reward-modal__participant-list">
                              {participantList.length > 0 ? (
                                participantList.map((item, index) => (
                                  <div className="manager-reward-modal__participant-item" key={item.id || index}>
                                    <strong>
                                      {item.name || [item.first_name, item.last_name].filter(Boolean).join(" ") || item.email}
                                    </strong>
                                    {item.email && <span>{item.email}</span>}
                                  </div>
                                ))
                              ) : (
                                <div className="manager-reward-modal__participant-empty">
                                  No participants selected.
                                </div>
                              )}
                            </div>
                            <div className="manager-reward-modal__metrics">
                              <div className="manager-reward-modal__metric">
                                <span className="manager-reward-modal__metric-label">Participants</span>
                                <strong className="manager-reward-modal__metric-value">{selectedCount}</strong>
                              </div>
                              {event && (
                                <div className="manager-reward-modal__metric">
                                  <span className="manager-reward-modal__metric-label">Event</span>
                                  <strong className="manager-reward-modal__metric-value">{selectedEventOption?.label || "Selected"}</strong>
                                </div>
                              )}
                              {isVariableAmountAward && (
                                <>
                                  <div className="manager-reward-modal__metric">
                                    <span className="manager-reward-modal__metric-label">Per Participant</span>
                                    <strong className="manager-reward-modal__metric-value">
                                      {amountToUsFormat(displayAwardValue, true, "$")}
                                    </strong>
                                  </div>
                                  <div className="manager-reward-modal__metric">
                                    <span className="manager-reward-modal__metric-label">Total Award</span>
                                    <strong className="manager-reward-modal__metric-value">
                                      {amountToUsFormat(totalAwardValue || 0, true, "$")}
                                    </strong>
                                  </div>
                                </>
                              )}
                              {event && isScheduledAwardEnabled(rootProgram, program, event) && (
                                <div className="manager-reward-modal__metric">
                                  <span className="manager-reward-modal__metric-label">Schedule</span>
                                  <strong className="manager-reward-modal__metric-value">{scheduledDateLabel}</strong>
                                </div>
                              )}
                            </div>
                          </section>
                        </aside>
                      </div>

                      <div className="manager-program-settings-dialog__actions manager-reward-modal__actions">
                        <button
                          type="button"
                          className="manager-program-settings-dialog__action"
                          onClick={toggle}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="manager-program-settings-dialog__action is-primary"
                          disabled={isSubmitDisabled}
                        >
                          {saving && <Spinner size="sm" />}
                          <span>Give Reward</span>
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Form>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    rootProgram: state.program?.rootProgram || state.rootProgram
  };
};
export default connect(mapStateToProps)(GiveRewardPopup);
